import { normalizar } from "./format";

const coloresStatus = {
  PREPARACION: "#fbbd08",
  BODEGA: "#2185d0",
  "TRANSITO PACIENTE": "#73b4e9ff",
  "TRANSITO ST": "#f2711c",
  "SERVICIO TECNICO": "#6435c9",
  PACIENTE: "#0d47a1",
  "TRANSITO BODEGA": "#00b5ad",
  BAJA: "#767676",
  "TRANSITO PROVEEDOR": "#db2828",
  PROVEEDOR: "#a333c8",
  "SIN STATUS": "#999999",
};

const generarColor = (texto = "") => {
  let hash = 0;

  for (let i = 0; i < texto.length; i++) {
    hash = texto.charCodeAt(i) + ((hash << 5) - hash);
  }

  return `hsl(${Math.abs(hash) % 360}, 65%, 55%)`;
};

export const getColorStatus = (status) => {
  const key = normalizar(status || "SIN STATUS");
  return coloresStatus[key] || generarColor(key);
};